import {Typography} from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import {useEffect, useState} from "react";
import useOrderState from "../../../stores/orderStore";
import SteddiContainer from "../../General/SteddiContainer";
import SteddiInfoItem from "../../General/SteddiInfoItem";
import {CalendarDays} from "lucide-react";
import DateHelpers from "../../../helpers/DateHelpers";
import Månedsbeløp from "../InfoItems/Månedsbeløp";
import useAppState from "../../../stores/appStateStore";
import PaymentFreeMonth3 from "../../General/PaymentFreeMonth3";
import {animateCSS} from "../../../helpers/Animation";
import SectionHeader from "../../General/SectionHeader";


export default function PaymentFreeMonthPage() {
  const state = useOrderState((state) => state)
  const appState = useAppState((state) => state)
  const [selectedAmount, setSelectedAmount] = useState(state.paymentFreeMonths?.length ?? 0)
  const [selectedMonths, setSelectedMonths] = useState<number[]>(state.paymentFreeMonths)

  useEffect(() => {
    if (state.orderHash) {
      const estimate = getEstimate()
      if (estimate)
        state.setPriceEstimate(estimate)
      animateCSS(".shakeMe", "headShake")
    }
  }, [selectedAmount])

  useEffect(() => {
    if (state.paymentFreeMonths.length != selectedAmount) {
      appState.setGoNextDisabled(true)
      appState.setGoNextTooltip("Mangler betalingsfri måned")
    } else {
      appState.setGoNextDisabled(false)
    }
  }, [state.paymentFreeMonths, selectedAmount])

  useEffect(() => {
    state.setPaymentFreeMonths(selectedMonths)
  }, [selectedMonths])

  function getEstimate() {
    switch (selectedAmount) {
      case 0:
        return state.priceEstimates?.none
      case 1:
        return state.priceEstimates?.single
      case 2:
        return state.priceEstimates?.double
    }
  }

  function handleChangeSelectedMonths(months: number[]) {
    setSelectedMonths(months)
  }

  function handleChangeSelectedAmount(amount: number) {
    setSelectedAmount(amount)
  }

  return (
    <Grid2 container spacing={2} padding={0}>
      <Grid2 xs={12}>
        <SectionHeader>Er det noen måneder du vil velge bort?</SectionHeader>
      </Grid2>
      <Grid2 xs={12}>
        <Typography>Du kan velge inntil to betalingsfrie måneder i året, hvis du vil. Vær oppmerksom på at du får et høyere månedsbeløp resten av månedene hvis du velger dette.</Typography>
      </Grid2>
      <Grid2>
        <Typography>I en betalingsfri måned får du en faktura som viser strøm- og nettleiekostnadene du har hatt hos strømleverandøren din. Disse kostnadene registreres på saldoen – men det blir ingen betaling til forfall den måneden.</Typography>
      </Grid2>
      <PaymentFreeMonth3 selectedMonths={selectedMonths} setSelectedMonths={handleChangeSelectedMonths} setSelectedAmount={handleChangeSelectedAmount} title={"Betalingsfri måned"} selectedAmount={selectedAmount} prices={state.priceEstimates}/>
      <Grid2 xs={12} sm={6}>
        <SteddiContainer padding="sm">
          <Månedsbeløp/>
        </SteddiContainer>
      </Grid2>
      <Grid2 xs={12} sm={6}>
        <SteddiContainer padding="sm">
          <SteddiInfoItem title={"Første forfallsdato"} subtitle={DateHelpers.toDateString(state.firstPaymentDue)} icon={<CalendarDays/>} bgColor={"secondary"}/>
        </SteddiContainer>
      </Grid2>
    </Grid2>
  )
}